import { createContext } from "react";

import type { CreateActionContextValue } from "./types";

export const CreateActionContext =
  createContext<CreateActionContextValue | null>(null);
CreateActionContext.displayName = "CreateActionContext";
